var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor assign-owner" }, [
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Contact ID")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Contact ID",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.contactId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "contactId", $$v)
            },
            expression: "clone.contactId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "title" }, [_vm._v("Atama Yöntemi")]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticClass: "classic-select",
            model: {
              value: _vm.clone.method,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "method", $$v)
              },
              expression: "clone.method",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "algorithmic" } }, [
              _vm._v("Algoritmik Atama"),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "static" } }, [
              _vm._v("Statik Atama"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.clone.method === "static"
      ? _c(
          "section",
          [
            _c("div", { staticClass: "title" }, [_vm._v("Atanacak Temsilci")]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticClass: "classic-select",
                attrs: { placeholder: "Temsilci seçiniz", "allow-clear": "" },
                model: {
                  value: _vm.clone.staticUserId,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "staticUserId", $$v)
                  },
                  expression: "clone.staticUserId",
                },
              },
              [
                _c("a-select-option", { attrs: { value: null } }, [
                  _vm._v("Sahipsiz (Owner Kaldır)"),
                ]),
                _vm._v(" "),
                _vm._l(_vm.users, function (user) {
                  return _c(
                    "a-select-option",
                    { key: user._id, attrs: { value: user._id } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(user.name) +
                          "\n            "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "Seçilen temsilci channel ve department ayarlarına uygun olmalıdır"
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.method === "algorithmic"
      ? _c(
          "section",
          [
            _c("div", { staticClass: "title" }, [_vm._v("Algoritma")]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticClass: "classic-select",
                model: {
                  value: _vm.clone.algorithm,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "algorithm", $$v)
                  },
                  expression: "clone.algorithm",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "least_contact" } }, [
                  _vm._v("En Az Kontağa Sahip Olan"),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "random" } }, [
                  _vm._v("Rastgele"),
                ]),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.method === "algorithmic"
      ? _c(
          "section",
          [
            _c("div", { staticClass: "title" }, [_vm._v("Tarih Aralığı")]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticClass: "classic-select",
                model: {
                  value: _vm.clone.dateRange,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "dateRange", $$v)
                  },
                  expression: "clone.dateRange",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "today" } }, [
                  _vm._v("Bugün"),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "last_7_days" } }, [
                  _vm._v("Son 7 Gün"),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "last_30_days" } }, [
                  _vm._v("Son 30 Gün"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "Temsilcilerin sahip olduğu kontak sayılarına bakılacak zaman aralığı"
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.method === "algorithmic"
      ? _c(
          "section",
          [
            _c("div", { staticClass: "title" }, [
              _vm._v("Sadece Online Olanlara Dağıt"),
            ]),
            _vm._v(" "),
            _c("a-switch", {
              model: {
                value: _vm.clone.checkOnlineStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "checkOnlineStatus", $$v)
                },
                expression: "clone.checkOnlineStatus",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.method === "algorithmic"
      ? _c(
          "section",
          [
            _c("div", { staticClass: "title" }, [
              _vm._v("Hariç Tutulacak Temsilciler"),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticClass: "classic-select",
                attrs: { mode: "multiple" },
                model: {
                  value: _vm.clone.excludeUserIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "excludeUserIds", $$v)
                  },
                  expression: "clone.excludeUserIds",
                },
              },
              _vm._l(_vm.users, function (user) {
                return _c(
                  "a-select-option",
                  { key: user._id, attrs: { value: user._id } },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(user.name) +
                        "\n            "
                    ),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("small", [
              _vm._v("Seçilen temsilciler atama havuzundan hariç tutulacaktır"),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }